module.exports = __webpack_public_path__ + "media/images/ask-a-question-avatar-f342782f7dbde12085bf533fae6754ac.png";